import Chart from 'react-apexcharts';

// ----------------------------------------------------------------------

export { default as StyledChart } from './Styles';

export { default as useChart } from './useChart';

export default Chart;
